




























































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DateClass from '@/app/module/date'
import Local from '@/app/module/local'

@Component
export default class MachineRentList extends Vue {
  private isActive: boolean = true
  private constantValue: any
  @Prop() private data!: any
  @Prop() private number!: any

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
  }

  private dateToStringYmd (date: any) {
    if (date !== null && date !== '') {
      return DateClass.dateToStringYmd(new Date(date), '年月日')
    } else {
      return ''
    }
  }

  private dateToStringYmdhm (date: any) {
    if (date !== null && date !== '') {
      return DateClass.dateToStringYmd(new Date(date), '年月日曜日時分')
    } else {
      return ''
    }
  }

  /* 機械タイプの判定 */
  private judgmentMachineType (type: number) {
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_id === type) {
        return this.constantValue.machine_types[i].machine_type_name
      }
    }
  }

  /* 貸出ステータスの判定 */
  private judgmentStatusName (step: number) {
    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].status_name
      }
    }
  }

  /*  行動ステップの判定 */
  private judgmentStepName (step: number) {
    if (step === null) {
      return '-'
    }

    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].step_name
      }
    }
  }

  private active () {
    this.isActive = !this.isActive
  }
}
